"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _getFormAsyncErrors = _interopRequireDefault(require("./selectors/getFormAsyncErrors"));

var _plain = _interopRequireDefault(require("./structure/plain"));

var _default = (0, _getFormAsyncErrors["default"])(_plain["default"]);

exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/getFormAsyncErrors.js
 ** module id = 625
 ** module chunks = 0 1
 **/